import { KeyValuePair } from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

/**
 * Client-side API wrapper for title reference data endpoints.
 */
export class TitleApi {
  /**
   * Loads available titles (Mr/Ms/etc.) for a country.
   *
   * @param countryCode Two-letter ISO country code.
   * @param token Bearer token used for authenticated requests.
   * @param successCallback Invoked with title key/value pairs on success.
   * @param failureCallback Invoked with an error message on failure.
   * @param signal Abort signal used to cancel the request.
   */
  async getTitlesAsync(
    countryCode: string,
    token: string,
    successCallback: (titles: KeyValuePair[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/title/title?countryCode=${countryCode}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
